(() => {
  'use strict';


  /* =========================================
    IRiller（アイリエ）
    Embroidery Customizer
    STEP 2-B⑭
  ========================================= */


  const MAX_LINE_LENGTH = 22;

  /* Shopify 刺繍サービス商品 */
  const EMBROIDERY_SERVICE_VARIANTS = {
    matte: 53389184336053,
    metallic: 53389184368821
  };

  /* メタリック刺繍糸：⑨シルバー・⑬ゴールド・⑭シャンパンゴールド */
  const METALLIC_THREAD_IDS = [9, 13, 14];

  const EMBROIDERY_SERVICE_PRICES = {
    matte: 3300,
    metallic: 5500
  };


  /* =========================================
    PRODUCT RULES
  ========================================= */

  const PRODUCT_RULES = {

    TBB20: {
      eligible: true,
      label: 'ツイードボウルブーケ',
      size: 20
    },

    TBB30: {
      eligible: true,
      label: 'ツイードボウルブーケ',
      size: 30
    },

    TBB33: {
      eligible: true,
      label: 'ツイードボウルブーケ',
      size: 33
    },

    TBB35: {
    eligible: true,
    label: 'ツイードボウルブーケ',
    size: 35
    },

    TBB50: {
      eligible: true,
      label: 'ツイードボウルブーケ',
      size: 50
    },

    TBB108: {
      eligible: true,
      label: 'ツイードボウルブーケ',
      size: 108
    },

    TBS: {
      eligible: false,
      label: 'ツイードボックスローズS'
    },

    TBBP: {
      eligible: false,
      label: 'ツイードボウルブーケ（プティサイズ）'
    },

    PTB: {
      eligible: false,
      label: 'プティツイードブーケ'
    }

  };


  /* =========================================
    SIZE EMBROIDERY IMAGES
    商品サイズ別の刺繍イメージ
  ========================================= */

  const EMBROIDERY_SIZE_IMAGES = {
    20: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/TBB20-embroidery-size-img.jpg?v=1790216721',
    30: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/TBB30-embroidery-size-img.jpg?v=1790214221',
    33: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/TBB30-embroidery-size-img.jpg?v=1790214221',
    50: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/TBB50-embroidery-size-img.jpg?v=1790214245',
    108: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/TBB108-embroidery-size-img.jpg?v=1790221323'
  };


  /* =========================================
    THREAD COLORS
    次STEP以降で使用
  ========================================= */

  const THREAD_COLORS = {

    1: '①オレンジ',
    2: '②イエロー',
    3: '③グリーン',
    4: '④ホワイト',
    5: '⑤パープル',
    6: '⑥ピンク',
    7: '⑦ワインレッド',
    8: '⑧ブラック',
    9: '⑨シルバー',
    10: '⑩エメラルド',
    11: '⑪スカイブルー',
    12: '⑫ロイヤルブルー',
    13: '⑬ゴールド',
    14: '⑭シャンパンゴールド',
    15: '⑮ポップピンク',
    16: '⑯ライトパープル'

  };


  /* =========================================
    THREAD SWATCHES
    画面上の選択補助用カラー
    ※実物刺繍糸の厳密な色指定ではありません
  ========================================= */

  const THREAD_SWATCHES = {
    1: '#ff853fff',
    2: '#ffc800ff',
    3: '#235020ff',
    4: '#F7F5F0',
    5: '#52286bff',
    6: '#e8aec0ff',
    7: '#de0606ff',
    8: '#222222',
    9: '#B9B9B9',
    10: '#78d2bfff',
    11: '#18b5f4ff',
    12: '#121e9fff',
    13: '#B58A2D',
    14: '#efd8b0ff',
    15: '#f75e9eff',
    16: '#ccb1e2ff'
  };


  /* =========================================
  FABRIC PREVIEW IMAGES
  即時プレビュー背景用
========================================= */

const EMBROIDERY_FABRIC_PREVIEW_IMAGES = {
  RRH: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/03.bishu-tweed-ririhibiki.jpg?v=1790238357',
  MMS: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/04-bishu-tweed-momoshizuku.jpg?v=1790238369',
  SKW: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/07-bishu-tweed-sukewabi.jpg?v=1790241669',
  AWS: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/05-bishu-tweed-awasumire.jpg?v=1790238379',
  KHK: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/06-bishu-tweed-kohaku.jpg?v=1790238391',
  KSN: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/01-bishu-tweed-kasanadeshiko.jpg?v=1790238259',
  HRL: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/11-bishu-tweed-harulemon.jpg?v=1790238464',
  TYU: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/09-bishu-tweed-tsuyautsukushi.jpg?v=1790241737',
  AMH: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/14-bishu-tweed-amaha-new.jpg?v=1791717595',
  HK: 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/13-bishu-tweed-houkou.jpg?v=1790238485'
};


  /* =========================================
    REAL EMBROIDERY SAMPLE IMAGES

    艶美(TYU) → 重撫子(KSN)を参照
    峰煌(HK)  → 凛々響(RRH)を参照
    （FABRICS.sampleSourceFabricで処理）
  ========================================= */

  const EMBROIDERY_SAMPLE_IMAGES = {
  RRH: {
    4: '',
    5: '',
    6: '',
    11: '',
    12: '',
    14: ''
  },

  MMS: {
    6: '',
    15: ''
  },

  SKW: {
    10: ''
  },

  AWS: {
    5: '',
    16: ''
  },

  KHK: {
    1: '',
    2: ''
  },

  KSN: {
    6: '',
    11: '',
    12: '',
    15: ''
  },

  HRL: {
    1: '',
    8: ''
  }
};


  /* =========================================
    FABRICS
  ========================================= */

  const FABRICS = {

    RRH: {
      label: '凛々響',
      embroideryAvailable: true,

      allowedThreads: [
        1, 2, 3, 4, 5, 6, 7, 9,
        10, 11, 12, 13, 14, 15, 16
      ],

      recommendedThreads: [9, 14],

      sampleThreads: [4, 5, 6, 11, 12, 14],

      note:
        'ラグジュアリーな仕上がりなら9番もしくは14番！'
    },


    HNG: {
      label: '華絹',
      embroideryAvailable: false,

      allowedThreads: [],
      recommendedThreads: [],
      sampleThreads: []
    },


    MMS: {
      label: '桃雫',
      embroideryAvailable: true,

      allowedThreads: [
        1, 2, 3, 5, 6, 7, 8,
        10, 11, 12, 13, 15, 16
      ],

      recommendedThreads: [6, 15],

      sampleThreads: [6, 15]
    },


    SKW: {
      label: '透山葵',
      embroideryAvailable: true,

      allowedThreads: [
        1, 2, 3, 5, 6, 7, 8,
        10, 11, 12, 13, 15, 16
      ],

      recommendedThreads: [10],

      sampleThreads: [10]
    },


    AWS: {
      label: '淡菫',
      embroideryAvailable: true,

      allowedThreads: [
        1, 2, 3, 5, 6, 7, 8,
        10, 11, 12, 13, 15, 16
      ],

      recommendedThreads: [16],

      sampleThreads: [5, 16, 12]
    },


    KHK: {
      label: '琥珀',
      embroideryAvailable: true,

      allowedThreads: [
        1, 2, 3, 5, 6, 7, 8,
        10, 11, 12, 15, 16
      ],

      recommendedThreads: [1],

      sampleThreads: [1, 2]
    },


    KSN: {
      label: '重撫子',
      embroideryAvailable: true,

      allowedThreads: [
        1, 3, 5, 6, 7, 8, 9,
        10, 11, 12, 13, 14, 15, 16
      ],

      recommendedThreads: [6,8,15],

      sampleThreads: [6, 11, 12, 15, 9, 14],

      note:
        'グリッターローズのカラーに合わせるのもおすすめ！'
    },


    URM: {
      label: '潤美月',
      embroideryAvailable: false,

      allowedThreads: [],
      recommendedThreads: [],
      sampleThreads: []
    },


    HRL: {
      label: '春檸檬',
      embroideryAvailable: true,

      allowedThreads: [
        1, 3, 5, 6, 7, 8,
        10, 11, 12, 15, 16
      ],

      recommendedThreads: [1],

      sampleThreads: [1, 8]
    },


    TYU: {
      label: '艶美',
      embroideryAvailable: true,

      allowedThreads: [
        1, 2, 3, 5, 6, 7, 8,
        10, 11, 12, 15, 16
      ],

      recommendedThreads: [],

      sampleThreads: [6, 11, 12, 15],

      sampleSourceFabric: 'KSN',

      note:
        'グリッターローズのカラーに合わせるのもおすすめ！'
    },


    MTA: {
      label: '蜜飴',
      embroideryAvailable: false,

      allowedThreads: [],
      recommendedThreads: [],
      sampleThreads: []
    },


    MOT: {
      label: '澪標',
      embroideryAvailable: false,

      allowedThreads: [],
      recommendedThreads: [],
      sampleThreads: []
    },

    AMH: {
  label: '天羽',
  embroideryAvailable: true,

  allowedThreads: [
    1, 2, 3, 5, 6, 7, 8,
    10, 11, 12, 15, 16
  ],

  recommendedThreads: [1, 5, 10, 11, 12, 15],
  sampleThreads: [],

  note: '2番や6番は、生地の色合いとの関係で刺繍文字が見えにくくなります。'
},


    HK: {
  label: '峰煌',
  embroideryAvailable: false,

  allowedThreads: [],
  recommendedThreads: [],
  sampleThreads: []
}

  };


  /* =========================================
    ODM NAME → CODE
  ========================================= */

  const FABRIC_NAME_TO_CODE = {

    '凛々響': 'RRH',
    '華絹': 'HNG',
    '桃雫': 'MMS',
    '透山葵': 'SKW',
    '淡菫': 'AWS',
    '琥珀': 'KHK',
    '重撫子': 'KSN',
    '潤美月': 'URM',
    '春檸檬': 'HRL',
    '艶美': 'TYU',
    '蜜飴': 'MTA',
    '澪標': 'MOT',
    '澪標（残りわずか）': 'MOT',
    '天羽': 'AMH',
    '峰煌': 'HK'

  };


  /* =========================================
    MESSAGE SCENES
  ========================================= */

  const MESSAGE_SCENES = {

    proposal: {

      label: 'プロポーズ',
      icon: '💍',

      messages: [

        {
          id: 'proposal_question',
          label: 'Will you marry me?',
          template: 'Will you marry me?',
          requiresNumber: false
        },

        {
          id: 'proposal_period',
          label: 'Marry me',
          template: 'Marry me',
          requiresNumber: false
        }

      ]

    },


    anniversary: {

      label: '記念日',
      icon: '♡',

      messages: [

        {
          id: 'happy_anniversary',
          label: 'Happy Anniversary',
          template: 'Happy Anniversary',
          requiresNumber: false
        },


        {
          id: 'ordinal_anniversary',
          label: '○th Anniversary',
          template: '{ordinal} Anniversary',
          requiresNumber: true,
          numberType: 'anniversary',
          question: '何年記念日ですか？',
          help: '数字のみ入力してください。',
          unit: '年'
        }

      ]

    },


    birthday: {

      label: '誕生日',
      icon: '🎂',

      messages: [

        {
          id: 'happy_birthday',
          label: 'Happy Birthday',
          template: 'Happy Birthday',
          requiresNumber: false
        },

        {
          id: 'happy_ordinal_birthday',
          label: 'Happy ○th Birthday',
          template: 'Happy {ordinal} Birthday',
          requiresNumber: true,
          numberType: 'age',
          question: '何歳のお誕生日ですか？',
          help: '数字のみ入力してください。',
          unit: '歳'
        },

        {
          id: 'ordinal_birthday',
          label: '○th Birthday',
          template: '{ordinal} Birthday',
          requiresNumber: true,
          numberType: 'age',
          question: '何歳のお誕生日ですか？',
          help: '数字のみ入力してください。',
          unit: '歳'
        }

      ]

    },


     /* =========================================
    クリスマス
  ========================================= */

  christmas: {

    label: 'クリスマス',
    icon: '🎄',

    messages: [

      {
        id: 'merry_christmas',
        label: 'Merry Christmas',
        template: 'Merry Christmas',
        requiresNumber: false
      },

      {
        id: 'merry_xmas',
        label: 'Merry X’mas',
        template: 'Merry X’mas',
        requiresNumber: false
      }

    ]

  },


  /* =========================================
    ホワイトデー
  ========================================= */

  whiteday: {

    label: 'ホワイトデー',
    icon: '🤍',

    messages: [

      {
        id: 'happy_whiteday',
        label: 'Happy Whiteday',
        template: 'Happy Whiteday',
        requiresNumber: false
      }

    ]

  },


  /* =========================================
    ブライダル
  ========================================= */

  bridal: {

  label: 'ブライダル',
  icon: '🤍',

  messages: [

    {
      id: 'happy_wedding',
      label: 'Happy Wedding',
      template: 'Happy Wedding',
      requiresNumber: false
    }

  ]

},


  /* =========================================
    成人式
  ========================================= */

  coming_of_age: {

    label: '成人式',
    icon: '🌸',

    messages: [

      {
        id: 'congratulations_adulthood',
        label: '成人おめでとう！',
        template: '成人おめでとう！',
        requiresNumber: false
      }

    ]

  },


  /* =========================================
    卒業式
  ========================================= */

  graduation: {

    label: '卒業式',
    icon: '🎓',

    messages: [

      {
        id: 'congratulations_graduation',
        label: '卒業おめでとう！',
        template: '卒業おめでとう！',
        requiresNumber: false
      }

    ]

  },

  /* =========================================
    母の日
  ========================================= */

  mothers_day: {

  label: '母の日',
  icon: '🌹',

  messages: [

    {
      id: 'happy_mothers_day',
      label: "Happy Mother's Day",
      template: "Happy Mother's Day",
      requiresNumber: false
    }

  ]

},

  };


  /* =========================================
    STATE
  ========================================= */

  function createInitialState() {

    return {

      confirmed: false,
      hasBeenConfirmed: false,
      confirmedSnapshot: '',

      sceneId: null,
      messageId: null,
      numberValue: '',
      generatedMessage: '',

      nameMode: null,
      firstName: '',
      secondName: '',
      connector: '&',
      generatedName: '',

      dateMode: null,
      dateYear: '',
      dateMonth: '',
      dateDay: '',
      generatedDate: '',

      lineOrder: [
        'message',
        'name',
        'date'
      ],

      threadColorId: null

    };
  }


  /* =========================================
    BASIC HELPERS
  ========================================= */

  function getCharacterLength(value) {

    return Array.from(
      value || ''
    ).length;
  }


  function isWithinLineLimit(value) {

    return (
      getCharacterLength(value) <=
      MAX_LINE_LENGTH
    );
  }


  function setValidation(
    element,
    message
  ) {

    if (!element) {

      return;
    }


    if (message) {

      element.textContent =
        message;


      element.classList.add(
        'is-visible'
      );

    } else {

      element.textContent =
        '';


      element.classList.remove(
        'is-visible'
      );
    }
  }


  function digitsOnly(
    value,
    maxLength
  ) {

    return String(
      value || ''
    )
      .replace(
        /[^0-9]/g,
        ''
      )
      .slice(
        0,
        maxLength
      );
  }


  /* =========================================
    ODM FABRIC
  ========================================= */

  
    
  function getSelectedOdmFabric() {

    const orderMadeRoot =
      document.querySelector(
        '[data-ir-order-made]'
      );


    const selected = orderMadeRoot
      ? orderMadeRoot.querySelector(
          '[data-ir-om-tweed-property]'
        )
      : document.querySelector(
          'input[name="properties[ツイード生地]"]:checked'
        );


    if (!selected) {

      return null;
    }


    const fabricName =
      String(selected.value || '').trim();


    const fabricCode =
      FABRIC_NAME_TO_CODE[
        fabricName
      ];


    if (!fabricCode) {

      return null;
    }


    return {

      code: fabricCode,
      name: fabricName

    };
  }



  /* =========================================
    SKU
  ========================================= */

  function parseSku(sku) {

    if (!sku) {

      return {
        productCode: null,
        fabricCode: null
      };
    }


    const parts =
      String(sku)
        .trim()
        .split('-');


    return {

      productCode:
        parts[0] || null,

      fabricCode:
        parts[1] || null

    };
  }


  /* =========================================
    ELIGIBILITY
  ========================================= */

  function getEmbroideryTarget(
    root,
    variant
  ) {

    const productTitle =
      root.dataset.productTitle || '';


    const sku =
      variant?.sku || '';


    /* -----------------------------------------
      当日発送は最優先で対象外
    ----------------------------------------- */

    if (
      productTitle.includes(
        '当日発送'
      )
    ) {

      return {

        eligible: false,
        reason: 'same_day',
        sku,

        message:
          '当日発送商品には刺繍加工を追加できません。'

      };
    }


    const parsed =
      parseSku(sku);


    const productRule =
      PRODUCT_RULES[
        parsed.productCode
      ];


    if (!productRule) {

      return {

        eligible: false,
        reason: 'unknown_product',
        sku,

        productCode:
          parsed.productCode,

        fabricCode:
          parsed.fabricCode,

        message:
          'この商品は刺繍サービス対象外です。'

      };
    }


    if (!productRule.eligible) {

      return {

        eligible: false,
        reason: 'unsupported_product',
        sku,

        productCode:
          parsed.productCode,

        productLabel:
          productRule.label,

        fabricCode:
          parsed.fabricCode,

        message:
          'この商品は刺繍サービス対象外です。'

      };
    }


    /* =========================================
      ODM
    ========================================= */

    if (
      parsed.fabricCode ===
      'ODM'
    ) {

      const odmFabric =
        getSelectedOdmFabric();


      if (!odmFabric) {

        return {

          eligible: null,
          reason: 'odm_waiting',
          sku,

          productCode:
            parsed.productCode,

          productLabel:
            productRule.label,

          size:
            productRule.size,

          fabricCode:
            'ODM',

          message:
            'ツイード生地を選択して、対応可否をご確認ください。'

        };
      }


      const fabric =
        FABRICS[
          odmFabric.code
        ];


      if (!fabric) {

        return {

          eligible: false,
          reason: 'unknown_fabric',
          sku,

          productCode:
            parsed.productCode,

          productLabel:
            productRule.label,

          size:
            productRule.size,

          fabricCode:
            odmFabric.code,

          fabricLabel:
            odmFabric.name,

          source:
            'order_form',

          message:
            'ツイード情報を確認できないため、刺繍可否を判定できません。'

        };
      }


      if (
        !fabric.embroideryAvailable
      ) {

        return {

          eligible: false,
          reason: 'unsupported_fabric',
          sku,

          productCode:
            parsed.productCode,

          productLabel:
            productRule.label,

          size:
            productRule.size,

          fabricCode:
            odmFabric.code,

          fabricLabel:
            fabric.label,

          source:
            'order_form',

          message:
            '生地の織り柄・色の特性上、現在の刺繍技術では文字の視認性や仕上がり品質を十分に確保できないため、刺繍サービス対象外です。'

        };
      }


      return {

        eligible: true,
        reason: 'available',
        sku,

        productCode:
          parsed.productCode,

        productLabel:
          productRule.label,

        size:
          productRule.size,

        fabricCode:
          odmFabric.code,

        fabricLabel:
          fabric.label,

        allowedThreads:
          fabric.allowedThreads,

        recommendedThreads:
          fabric.recommendedThreads,

        sampleThreads:
          fabric.sampleThreads,

        sampleSourceFabric:
          fabric.sampleSourceFabric ||
          odmFabric.code,

        note:
          fabric.note || '',

        source:
          'order_form'

      };
    }


    /* =========================================
      NORMAL SKU
    ========================================= */

    const fabric =
      FABRICS[
        parsed.fabricCode
      ];


    if (!fabric) {

      return {

        eligible: false,
        reason: 'unknown_fabric',
        sku,

        productCode:
          parsed.productCode,

        productLabel:
          productRule.label,

        size:
          productRule.size,

        fabricCode:
          parsed.fabricCode,

        message:
          'ツイード情報を確認できないため、刺繍可否を判定できません。'

      };
    }


    if (
      !fabric.embroideryAvailable
    ) {

      return {

        eligible: false,
        reason: 'unsupported_fabric',
        sku,

        productCode:
          parsed.productCode,

        productLabel:
          productRule.label,

        size:
          productRule.size,

        fabricCode:
          parsed.fabricCode,

        fabricLabel:
          fabric.label,

        message:
          '生地の織り柄・色の特性上、現在の刺繍技術では文字の視認性や仕上がり品質を十分に確保できないため、刺繍サービス対象外です。'

      };
    }


    return {

      eligible: true,
      reason: 'available',
      sku,

      productCode:
        parsed.productCode,

      productLabel:
        productRule.label,

      size:
        productRule.size,

      fabricCode:
        parsed.fabricCode,

      fabricLabel:
        fabric.label,

      allowedThreads:
        fabric.allowedThreads,

      recommendedThreads:
        fabric.recommendedThreads,

      sampleThreads:
        fabric.sampleThreads,

      sampleSourceFabric:
        fabric.sampleSourceFabric ||
        parsed.fabricCode,

      note:
        fabric.note || '',

      source:
        'sku'

    };
  }


  /* =========================================
    ORDINAL
  ========================================= */

  function toOrdinal(number) {

    const value =
      Number(number);


    if (
      !Number.isInteger(value) ||
      value <= 0
    ) {

      return '';
    }


    const lastTwo =
      value % 100;


    if (
      lastTwo >= 11 &&
      lastTwo <= 13
    ) {

      return `${value}th`;
    }


    switch (
      value % 10
    ) {

      case 1:
        return `${value}st`;

      case 2:
        return `${value}nd`;

      case 3:
        return `${value}rd`;

      default:
        return `${value}th`;

    }
  }


  /* =========================================
    MESSAGE HELPERS
  ========================================= */

  function getScene(sceneId) {

    return (
      MESSAGE_SCENES[
        sceneId
      ] || null
    );
  }


  function getMessageConfig(
    sceneId,
    messageId
  ) {

    const scene =
      getScene(sceneId);


    if (!scene) {

      return null;
    }


    return (
      scene.messages.find(
        message =>
          message.id ===
          messageId
      ) || null
    );
  }


  function generateMessage(root) {

    const state =
      root.irEmbroideryState;


    if (
      !state ||
      !state.sceneId ||
      !state.messageId
    ) {

      return '';
    }


    const message =
      getMessageConfig(
        state.sceneId,
        state.messageId
      );


    if (!message) {

      return '';
    }


    if (
      !message.requiresNumber
    ) {

      return message.template;
    }


    const ordinal =
      toOrdinal(
        state.numberValue
      );


    if (!ordinal) {

      return '';
    }


    return message.template.replace(
      '{ordinal}',
      ordinal
    );
  }


  /* =========================================
    NAME
  ========================================= */

  function generateName(root) {

    const state =
      root.irEmbroideryState;


    if (!state) {

      return '';
    }


    if (
      state.nameMode ===
      'none'
    ) {

      return '';
    }


    if (
      state.nameMode ===
      'one'
    ) {

      return (
        state.firstName || ''
      ).trim();
    }


    if (
      state.nameMode ===
      'two'
    ) {

      const first =
        (
          state.firstName ||
          ''
        ).trim();


      const second =
        (
          state.secondName ||
          ''
        ).trim();


      if (
        !first ||
        !second
      ) {

        return '';
      }


      return `${first} ${state.connector} ${second}`;
    }


    return '';
  }


  /* =========================================
    DATE
  ========================================= */

  function isLeapYear(year) {

    return (
      year % 400 === 0 ||
      (
        year % 4 === 0 &&
        year % 100 !== 0
      )
    );
  }


  function getDaysInMonth(
    year,
    month
  ) {

    const days = [
      31,
      isLeapYear(year) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31
    ];


    return (
      days[
        month - 1
      ] || 0
    );
  }


  function getDateValidation(root) {

    const state =
      root.irEmbroideryState;


    if (
      state.dateMode !==
      'include'
    ) {

      return {
        valid: false,
        complete: false,
        message: ''
      };
    }


    const yearText =
      state.dateYear;


    const monthText =
      state.dateMonth;


    const dayText =
      state.dateDay;


    if (
      !yearText ||
      !monthText ||
      !dayText
    ) {

      return {
        valid: false,
        complete: false,
        message: ''
      };
    }


    if (
      yearText.length !== 4
    ) {

      return {
        valid: false,
        complete: true,
        message:
          '年は4桁で入力してください。'
      };
    }


    const year =
      Number(yearText);


    const month =
      Number(monthText);


    const day =
      Number(dayText);


    if (
      !Number.isInteger(year) ||
      year <= 0
    ) {

      return {
        valid: false,
        complete: true,
        message:
          '正しい年を入力してください。'
      };
    }


    if (
      !Number.isInteger(month) ||
      month < 1 ||
      month > 12
    ) {

      return {
        valid: false,
        complete: true,
        message:
          '月は1〜12の数字で入力してください。'
      };
    }


    const maxDay =
      getDaysInMonth(
        year,
        month
      );


    if (
      !Number.isInteger(day) ||
      day < 1 ||
      day > maxDay
    ) {

      return {
        valid: false,
        complete: true,
        message:
          `${year}年${month}月には${day}日はありません。正しい日付を入力してください。`
      };
    }


    return {
      valid: true,
      complete: true,
      message: ''
    };
  }


  function generateDate(root) {

    const state =
      root.irEmbroideryState;


    if (
      !state ||
      state.dateMode !==
      'include'
    ) {

      return '';
    }


    const validation =
      getDateValidation(root);


    if (
      !validation.valid
    ) {

      return '';
    }


    const year =
      String(
        Number(
          state.dateYear
        )
      ).padStart(
        4,
        '0'
      );


    const month =
      String(
        Number(
          state.dateMonth
        )
      ).padStart(
        2,
        '0'
      );


    const day =
      String(
        Number(
          state.dateDay
        )
      ).padStart(
        2,
        '0'
      );


    return `${year}.${month}.${day}`;
  }


    /* =========================================
    SIZE EMBROIDERY IMAGE
    商品サイズに合わせて刺繍イメージを表示
  ========================================= */

  function updateEmbroiderySizeImage(
    root,
    target
  ) {

    const section =
      root.querySelector(
        '[data-ir-size-image-section]'
      );

    const image =
      root.querySelector(
        '[data-ir-size-image]'
      );

    const title =
      root.querySelector(
        '[data-ir-size-image-title]'
      );


    if (
      !section ||
      !image ||
      !title
    ) {

      return;
    }


    const size =
      target?.size;


    const imageUrl =
      size
        ? EMBROIDERY_SIZE_IMAGES[size]
        : '';


    /* サイズまたは画像がない場合は非表示 */

    if (
      !size ||
      !imageUrl
    ) {

      section.hidden = true;

      image.removeAttribute(
        'src'
      );

      image.alt = '';

      return;
    }


    /* 見出し */

    title.textContent =
      `${size}本サイズの刺繍イメージ`;


    /* 画像 */

    image.src =
      imageUrl;

    image.alt =
      `${size}本サイズに3段刺繍した場合のイメージ`;


    /* 表示 */

    section.hidden =
      false;
  }

  /* =========================================
    PREVIEW
  ========================================= */

  function getLineContent(root) {

    const state =
      root.irEmbroideryState;


    const message =
      generateMessage(root);


    const name =
      generateName(root);


    const date =
      generateDate(root);


    state.generatedMessage =
      message;


    state.generatedName =
      name;


    state.generatedDate =
      date;


    return {
      message:
        message &&
        isWithinLineLimit(message)
          ? message
          : '',

      name:
        name &&
        isWithinLineLimit(name)
          ? name
          : '',

      date:
        date &&
        isWithinLineLimit(date)
          ? date
          : ''
    };
  }


  function getActiveOrderedKeys(
    root,
    content
  ) {

    const state =
      root.irEmbroideryState;


    const order =
      Array.isArray(
        state.lineOrder
      )
        ? state.lineOrder
        : [
            'message',
            'name',
            'date'
          ];


    return order.filter(
      key =>
        Boolean(
          content[key]
        )
    );
  }


  function getPreviewLines(root) {

    const content =
      getLineContent(root);


    const activeKeys =
      getActiveOrderedKeys(
        root,
        content
      );


    return activeKeys.map(
      key =>
        content[key]
    );
  }


  function getOrderTypeLabel(key) {

    const labels = {
      message: 'メッセージ',
      name: 'お名前',
      date: '日付'
    };


    return (
      labels[key] ||
      key
    );
  }


  function renderOrderControl(root) {

    const list =
      root.querySelector(
        '[data-ir-order-list]'
      );


    const empty =
      root.querySelector(
        '[data-ir-order-empty]'
      );


    if (
      !list ||
      !empty
    ) {

      return;
    }


    const content =
      getLineContent(root);


    const activeKeys =
      getActiveOrderedKeys(
        root,
        content
      );


    list.innerHTML =
      '';


    if (
      activeKeys.length === 0
    ) {

      empty.hidden =
        false;


      list.hidden =
        true;


      return;
    }


    empty.hidden =
      true;


    list.hidden =
      false;


    activeKeys.forEach(
      (
        key,
        index
      ) => {

        const item =
          document.createElement(
            'div'
          );


        item.className =
          'ir-embroidery-order__item';


        item.dataset.irOrderKey =
          key;


        const position =
          document.createElement(
            'span'
          );


        position.className =
          'ir-embroidery-order__position';


        position.textContent =
          `${index + 1}段目`;


        const contentBox =
          document.createElement(
            'div'
          );


        contentBox.className =
          'ir-embroidery-order__content';


        const type =
          document.createElement(
            'span'
          );


        type.className =
          'ir-embroidery-order__type';


        type.textContent =
          getOrderTypeLabel(
            key
          );


        const text =
          document.createElement(
            'span'
          );


        text.className =
          'ir-embroidery-order__text';


        text.textContent =
          content[key];


        contentBox.appendChild(
          type
        );


        contentBox.appendChild(
          text
        );


        const buttons =
          document.createElement(
            'div'
          );


        buttons.className =
          'ir-embroidery-order__buttons';


        const up =
          document.createElement(
            'button'
          );


        up.type =
          'button';


        up.className =
          'ir-embroidery-order__move';


        up.dataset.irOrderMove =
          'up';


        up.dataset.irOrderKey =
          key;


        up.setAttribute(
          'aria-label',
          `${getOrderTypeLabel(key)}を1段上へ移動`
        );


        up.textContent =
          '↑';


        up.disabled =
          index === 0;


        const down =
          document.createElement(
            'button'
          );


        down.type =
          'button';


        down.className =
          'ir-embroidery-order__move';


        down.dataset.irOrderMove =
          'down';


        down.dataset.irOrderKey =
          key;


        down.setAttribute(
          'aria-label',
          `${getOrderTypeLabel(key)}を1段下へ移動`
        );


        down.textContent =
          '↓';


        down.disabled =
          index ===
          activeKeys.length - 1;


        buttons.appendChild(
          up
        );


        buttons.appendChild(
          down
        );


        item.appendChild(
          position
        );


        item.appendChild(
          contentBox
        );


        item.appendChild(
          buttons
        );


        list.appendChild(
          item
        );

      }
    );
  }


  function moveOrderItem(
    root,
    key,
    direction
  ) {

    const state =
      root.irEmbroideryState;


    const content =
      getLineContent(root);


    const activeKeys =
      getActiveOrderedKeys(
        root,
        content
      );


    const activeIndex =
      activeKeys.indexOf(
        key
      );


    if (
      activeIndex === -1
    ) {

      return;
    }


    const targetActiveIndex =
      direction === 'up'
        ? activeIndex - 1
        : activeIndex + 1;


    if (
      targetActiveIndex < 0 ||
      targetActiveIndex >=
        activeKeys.length
    ) {

      return;
    }


    const otherKey =
      activeKeys[
        targetActiveIndex
      ];


    const fullOrder =
      state.lineOrder;


    const keyIndex =
      fullOrder.indexOf(
        key
      );


    const otherIndex =
      fullOrder.indexOf(
        otherKey
      );


    if (
      keyIndex === -1 ||
      otherIndex === -1
    ) {

      return;
    }


    [
      fullOrder[keyIndex],
      fullOrder[otherIndex]
    ] = [
      fullOrder[otherIndex],
      fullOrder[keyIndex]
    ];


    updatePreview(root);
  }


  function setupOrderControl(root) {

    const list =
      root.querySelector(
        '[data-ir-order-list]'
      );


    if (!list) {

      return;
    }


    list.addEventListener(
      'click',
      event => {

        const button =
          event.target.closest(
            '[data-ir-order-move]'
          );


        if (
          !button ||
          button.disabled
        ) {

          return;
        }


        moveOrderItem(
          root,
          button.dataset.irOrderKey,
          button.dataset.irOrderMove
        );

      }
    );
  }


  function updatePreview(root) {

    invalidateEmbroideryConfirmation(root);

    const preview =
      root.querySelector('[data-ir-preview-text]');

    const finalPreview =
      root.querySelector('[data-ir-final-preview-text]');

    const finalThreadValue =
      root.querySelector('[data-ir-final-thread-value]');

    if (!preview && !finalPreview) {
  return;
}

    const lines =
      getPreviewLines(root);

    renderOrderControl(root);

    const renderPreviewLines = (target, isFinal) => {

      if (!target) {
        return;
      }

      target.innerHTML = '';

      if (lines.length === 0) {

        const placeholder =
          document.createElement('span');

        placeholder.className =
          'ir-embroidery-preview__placeholder';

        placeholder.innerHTML =
          isFinal
            ? '刺繍内容を入力すると<br>ここに最終イメージが表示されます'
            : '刺繍内容を選択すると<br>ここに刺繍イメージが表示されます';

        target.appendChild(placeholder);
        return;
      }

      lines.forEach(line => {

        const element =
          document.createElement('span');

        element.className =
          'ir-embroidery-preview__line';

        element.textContent = line;

        target.appendChild(element);
      });
    };

    renderPreviewLines(preview, false);
    renderPreviewLines(finalPreview, true);

    updatePreviewFabricBackground(root);
    updatePreviewThreadColor(root);

    if (finalThreadValue) {

      const threadId =
        root.irEmbroideryState?.threadColorId;

      finalThreadValue.textContent =
        threadId
          ? getThreadColorName(threadId)
          : '未選択';
    }
  }


  /* =========================================
    SCENES
  ========================================= */

  function renderSceneOptions(root) {

    const container =
      root.querySelector(
        '[data-ir-scene-options]'
      );


    if (!container) {

      return;
    }


    container.innerHTML =
      '';


    Object.entries(
      MESSAGE_SCENES
    ).forEach(
      ([sceneId, scene]) => {

        const button =
          document.createElement(
            'button'
          );


        button.type =
          'button';


        button.className =
          'ir-embroidery-scene-button';


        button.dataset.sceneId =
          sceneId;


        button.setAttribute(
          'aria-pressed',
          'false'
        );

        const label =
          document.createElement(
            'span'
          );


        label.className =
          'ir-embroidery-scene-button__label';


        label.textContent =
          scene.label;


        button.appendChild(label);


        button.addEventListener(
          'click',
          function () {

            selectScene(
              root,
              sceneId
            );

          }
        );


        container.appendChild(
          button
        );

      }
    );
  }


  function selectScene(
    root,
    sceneId
  ) {

    const state =
      root.irEmbroideryState;


    state.sceneId =
      sceneId;


    state.messageId =
      null;


    state.numberValue =
      '';


    state.generatedMessage =
      '';


    root
      .querySelectorAll(
        '[data-scene-id]'
      )
      .forEach(
        button => {

          const selected =
            button.dataset.sceneId ===
            sceneId;


          button.classList.toggle(
            'is-selected',
            selected
          );


          button.setAttribute(
            'aria-pressed',
            String(selected)
          );

        }
      );


    renderMessageOptions(
      root,
      sceneId
    );


    hideNumberField(root);


    updateMessageValidation(root);

    updatePreview(root);
  }


  /* =========================================
    MESSAGE OPTIONS
  ========================================= */

  function renderMessageOptions(
    root,
    sceneId
  ) {

    const scene =
      getScene(sceneId);


    const field =
      root.querySelector(
        '[data-ir-message-field]'
      );


    const container =
      root.querySelector(
        '[data-ir-message-options]'
      );


    if (
      !scene ||
      !field ||
      !container
    ) {

      return;
    }


    container.innerHTML =
      '';


    scene.messages.forEach(
      message => {

        const button =
          document.createElement(
            'button'
          );


        button.type =
          'button';


        button.className =
          'ir-embroidery-message-button';


        button.dataset.messageId =
          message.id;


        button.setAttribute(
          'aria-pressed',
          'false'
        );


        button.textContent =
          message.label;


        button.addEventListener(
          'click',
          function () {

            selectMessage(
              root,
              message.id
            );

          }
        );


        container.appendChild(
          button
        );

      }
    );


    field.hidden =
      false;
  }


  function selectMessage(
    root,
    messageId
  ) {

    const state =
      root.irEmbroideryState;


    state.messageId =
      messageId;


    state.numberValue =
      '';


    state.generatedMessage =
      '';


    const message =
      getMessageConfig(
        state.sceneId,
        messageId
      );


    root
      .querySelectorAll(
        '[data-message-id]'
      )
      .forEach(
        button => {

          const selected =
            button.dataset.messageId ===
            messageId;


          button.classList.toggle(
            'is-selected',
            selected
          );


          button.setAttribute(
            'aria-pressed',
            String(selected)
          );

        }
      );


    if (
      message &&
      message.requiresNumber
    ) {

      showNumberField(
        root,
        message
      );

    } else {

      hideNumberField(root);
    }


    updateMessageValidation(root);

    updatePreview(root);
  }


  /* =========================================
    NUMBER
  ========================================= */

  function showNumberField(
    root,
    message
  ) {

    const field =
      root.querySelector(
        '[data-ir-number-field]'
      );


    const title =
      root.querySelector(
        '[data-ir-number-title]'
      );


    const help =
      root.querySelector(
        '[data-ir-number-help]'
      );


    const unit =
      root.querySelector(
        '[data-ir-number-unit]'
      );


    const input =
      root.querySelector(
        '[data-ir-number-input]'
      );


    const result =
      root.querySelector(
        '[data-ir-number-result]'
      );


    if (!field) {

      return;
    }


    field.hidden =
      false;


    if (title) {

      title.textContent =
        message.question ||
        '数字を入力してください';
    }


    if (help) {

      help.textContent =
        message.help ||
        '数字のみ入力してください。';
    }


    if (unit) {

      unit.textContent =
        message.unit || '';
    }


    if (input) {

      input.value =
        '';


      input.placeholder =
        message.numberType ===
        'age'
          ? '30'
          : '5';


      window.setTimeout(
        () => {

          input.focus();

        },
        50
      );
    }


    if (result) {

      result.textContent =
        '';
    }
  }


  function hideNumberField(root) {

    const field =
      root.querySelector(
        '[data-ir-number-field]'
      );


    const input =
      root.querySelector(
        '[data-ir-number-input]'
      );


    const result =
      root.querySelector(
        '[data-ir-number-result]'
      );


    if (field) {

      field.hidden =
        true;
    }


    if (input) {

      input.value =
        '';
    }


    if (result) {

      result.textContent =
        '';
    }
  }


  function setupNumberInput(root) {

    const input =
      root.querySelector(
        '[data-ir-number-input]'
      );


    const result =
      root.querySelector(
        '[data-ir-number-result]'
      );


    if (!input) {

      return;
    }


    input.addEventListener(
      'input',
      function () {

        let numericOnly =
          digitsOnly(
            input.value,
            3
          );


        if (
          numericOnly.length > 1
        ) {

          numericOnly =
            numericOnly.replace(
              /^0+/,
              ''
            );


          if (
            numericOnly ===
            ''
          ) {

            numericOnly =
              '0';
          }
        }


        input.value =
          numericOnly;


        root.irEmbroideryState.numberValue =
          numericOnly;


        const ordinal =
          toOrdinal(
            numericOnly
          );


        if (result) {

          result.textContent =
            ordinal
              ? `英語表記：${ordinal}`
              : '';
        }


        updateMessageValidation(root);

        updatePreview(root);

      }
    );
  }


  function updateMessageValidation(root) {

    const validation =
      root.querySelector(
        '[data-ir-message-validation]'
      );


    const state =
      root.irEmbroideryState;


    const message =
      getMessageConfig(
        state.sceneId,
        state.messageId
      );


    if (
      !message ||
      !message.requiresNumber
    ) {

      setValidation(
        validation,
        ''
      );

      return;
    }


    const generated =
      generateMessage(root);


    if (!state.numberValue) {

      setValidation(
        validation,
        ''
      );

      return;
    }


    if (!generated) {

      setValidation(
        validation,
        '1以上の数字を入力してください。'
      );

      return;
    }


    if (
      !isWithinLineLimit(
        generated
      )
    ) {

      setValidation(
        validation,
        `刺繍できる文字数は1行${MAX_LINE_LENGTH}文字までです。数字を変更してください。`
      );

      return;
    }


    setValidation(
      validation,
      ''
    );
  }


  /* =========================================
    NAME MODE
  ========================================= */

  function setupNameMode(root) {

    root
      .querySelectorAll(
        '[data-ir-name-mode]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            function () {

              selectNameMode(
                root,
                button.dataset.irNameMode
              );

            }
          );

        }
      );
  }


  function selectNameMode(
    root,
    mode
  ) {

    const state =
      root.irEmbroideryState;


    state.nameMode =
      mode;


    state.firstName =
      '';


    state.secondName =
      '';


    state.connector =
      '&';


    state.generatedName =
      '';


    root
      .querySelectorAll(
        '[data-ir-name-mode]'
      )
      .forEach(
        button => {

          const selected =
            button.dataset.irNameMode ===
            mode;


          button.classList.toggle(
            'is-selected',
            selected
          );


          button.setAttribute(
            'aria-pressed',
            String(selected)
          );

        }
      );


    resetNameInputs(root);


    const oneField =
      root.querySelector(
        '[data-ir-one-name-field]'
      );


    const twoField =
      root.querySelector(
        '[data-ir-two-name-field]'
      );


    if (oneField) {

      oneField.hidden =
        mode !== 'one';
    }


    if (twoField) {

      twoField.hidden =
        mode !== 'two';
    }


    if (
      mode === 'one'
    ) {

      window.setTimeout(
        () => {

          root
            .querySelector(
              '[data-ir-first-name]'
            )
            ?.focus();

        },
        50
      );
    }


    if (
      mode === 'two'
    ) {

      window.setTimeout(
        () => {

          root
            .querySelector(
              '[data-ir-first-name-two]'
            )
            ?.focus();

        },
        50
      );
    }


    updateNameValidation(root);

    updatePreview(root);
  }


  /* =========================================
    NAME INPUT
  ========================================= */

  function sanitizeNameInput(value) {

    return String(
      value || ''
    )
      .replace(
        /[^A-Za-z0-9 ]/g,
        ''
      )
      .replace(
        /\s{2,}/g,
        ' '
      );
  }


  function setupNameInputs(root) {

    const oneName =
      root.querySelector(
        '[data-ir-first-name]'
      );


    const firstTwo =
      root.querySelector(
        '[data-ir-first-name-two]'
      );


    const secondTwo =
      root.querySelector(
        '[data-ir-second-name]'
      );


    if (oneName) {

      oneName.addEventListener(
        'input',
        function () {

          const sanitized =
            sanitizeNameInput(
              oneName.value
            );


          oneName.value =
            sanitized;


          root.irEmbroideryState.firstName =
            sanitized;


          updateNameValidation(root);

          updatePreview(root);

        }
      );
    }


    if (firstTwo) {

      firstTwo.addEventListener(
        'input',
        function () {

          const sanitized =
            sanitizeNameInput(
              firstTwo.value
            );


          firstTwo.value =
            sanitized;


          root.irEmbroideryState.firstName =
            sanitized;


          updateNameValidation(root);

          updatePreview(root);

        }
      );
    }


    if (secondTwo) {

      secondTwo.addEventListener(
        'input',
        function () {

          const sanitized =
            sanitizeNameInput(
              secondTwo.value
            );


          secondTwo.value =
            sanitized;


          root.irEmbroideryState.secondName =
            sanitized;


          updateNameValidation(root);

          updatePreview(root);

        }
      );
    }
  }


  /* =========================================
    CONNECTOR
  ========================================= */

  function setupConnectors(root) {

    root
      .querySelectorAll(
        '[data-ir-connector]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            function () {

              const connector =
                button.dataset.irConnector;


              root.irEmbroideryState.connector =
                connector;


              root
                .querySelectorAll(
                  '[data-ir-connector]'
                )
                .forEach(
                  item => {

                    const selected =
                      item.dataset.irConnector ===
                      connector;


                    item.classList.toggle(
                      'is-selected',
                      selected
                    );


                    item.setAttribute(
                      'aria-pressed',
                      String(selected)
                    );

                  }
                );


              updateNameValidation(root);

              updatePreview(root);

            }
          );

        }
      );
  }


  /* =========================================
    NAME VALIDATION
  ========================================= */

  function updateNameValidation(root) {

    const state =
      root.irEmbroideryState;


    const oneInput =
      root.querySelector(
        '[data-ir-first-name]'
      );


    const firstTwo =
      root.querySelector(
        '[data-ir-first-name-two]'
      );


    const secondTwo =
      root.querySelector(
        '[data-ir-second-name]'
      );


    const oneCount =
      root.querySelector(
        '[data-ir-one-name-count]'
      );


    const twoCount =
      root.querySelector(
        '[data-ir-two-name-count]'
      );


    const oneValidation =
      root.querySelector(
        '[data-ir-one-name-validation]'
      );


    const twoValidation =
      root.querySelector(
        '[data-ir-two-name-validation]'
      );


    const result =
      root.querySelector(
        '[data-ir-name-result]'
      );


    if (
      state.nameMode ===
      'one'
    ) {

      const generated =
        generateName(root);


      const length =
        getCharacterLength(
          generated
        );


      if (oneCount) {

        oneCount.textContent =
          `${length} / ${MAX_LINE_LENGTH}`;
      }


      const tooLong =
        length >
        MAX_LINE_LENGTH;


      oneInput?.classList.toggle(
        'has-error',
        tooLong
      );


      setValidation(
        oneValidation,
        tooLong
          ? `刺繍できる文字数は1行${MAX_LINE_LENGTH}文字までです。`
          : ''
      );


      state.generatedName =
        generated;


      return;
    }


    if (
      state.nameMode ===
      'two'
    ) {

      const generated =
        generateName(root);


      const length =
        getCharacterLength(
          generated
        );


      if (twoCount) {

        twoCount.textContent =
          `${length} / ${MAX_LINE_LENGTH}`;
      }


      if (result) {

        result.textContent =
          generated
            ? `刺繍イメージ：${generated}`
            : '';
      }


      const tooLong =
        length >
        MAX_LINE_LENGTH;


      firstTwo?.classList.toggle(
        'has-error',
        tooLong
      );


      secondTwo?.classList.toggle(
        'has-error',
        tooLong
      );


      setValidation(
        twoValidation,
        tooLong
          ? `2名のお名前と記号を合わせて1行${MAX_LINE_LENGTH}文字までです。お名前を短くしてご入力ください。`
          : ''
      );


      state.generatedName =
        generated;


      return;
    }


    if (oneCount) {

      oneCount.textContent =
        `0 / ${MAX_LINE_LENGTH}`;
    }


    if (twoCount) {

      twoCount.textContent =
        `0 / ${MAX_LINE_LENGTH}`;
    }


    if (result) {

      result.textContent =
        '';
    }


    oneInput?.classList.remove(
      'has-error'
    );


    firstTwo?.classList.remove(
      'has-error'
    );


    secondTwo?.classList.remove(
      'has-error'
    );


    setValidation(
      oneValidation,
      ''
    );


    setValidation(
      twoValidation,
      ''
    );


    state.generatedName =
      '';
  }


  function resetNameInputs(root) {

    const inputs = [

      root.querySelector(
        '[data-ir-first-name]'
      ),

      root.querySelector(
        '[data-ir-first-name-two]'
      ),

      root.querySelector(
        '[data-ir-second-name]'
      )

    ];


    inputs.forEach(
      input => {

        if (!input) {

          return;
        }


        input.value =
          '';


        input.classList.remove(
          'has-error'
        );

      }
    );


    root
      .querySelectorAll(
        '[data-ir-connector]'
      )
      .forEach(
        button => {

          const selected =
            button.dataset.irConnector ===
            '&';


          button.classList.toggle(
            'is-selected',
            selected
          );


          button.setAttribute(
            'aria-pressed',
            String(selected)
          );

        }
      );


    const oneCount =
      root.querySelector(
        '[data-ir-one-name-count]'
      );


    const twoCount =
      root.querySelector(
        '[data-ir-two-name-count]'
      );


    const result =
      root.querySelector(
        '[data-ir-name-result]'
      );


    if (oneCount) {

      oneCount.textContent =
        `0 / ${MAX_LINE_LENGTH}`;
    }


    if (twoCount) {

      twoCount.textContent =
        `0 / ${MAX_LINE_LENGTH}`;
    }


    if (result) {

      result.textContent =
        '';
    }


    setValidation(
      root.querySelector(
        '[data-ir-one-name-validation]'
      ),
      ''
    );


    setValidation(
      root.querySelector(
        '[data-ir-two-name-validation]'
      ),
      ''
    );
  }


  /* =========================================
    DATE MODE
  ========================================= */

  function setupDateMode(root) {

    root
      .querySelectorAll(
        '[data-ir-date-mode]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            function () {

              selectDateMode(
                root,
                button.dataset.irDateMode
              );

            }
          );

        }
      );
  }


  function selectDateMode(
    root,
    mode
  ) {

    const state =
      root.irEmbroideryState;


    state.dateMode =
      mode;


    state.dateYear =
      '';


    state.dateMonth =
      '';


    state.dateDay =
      '';


    state.generatedDate =
      '';


    root
      .querySelectorAll(
        '[data-ir-date-mode]'
      )
      .forEach(
        button => {

          const selected =
            button.dataset.irDateMode ===
            mode;


          button.classList.toggle(
            'is-selected',
            selected
          );


          button.setAttribute(
            'aria-pressed',
            String(selected)
          );

        }
      );


    resetDateInputs(root);


    const field =
      root.querySelector(
        '[data-ir-date-field]'
      );


    if (field) {

      field.hidden =
        mode !== 'include';
    }


    if (
      mode === 'include'
    ) {

      window.setTimeout(
        () => {

          root
            .querySelector(
              '[data-ir-date-year]'
            )
            ?.focus();

        },
        50
      );
    }


    updateDateValidation(root);

    updatePreview(root);
  }


  /* =========================================
    DATE INPUT
  ========================================= */

  function setupDateInputs(root) {

    const yearInput =
      root.querySelector(
        '[data-ir-date-year]'
      );


    const monthInput =
      root.querySelector(
        '[data-ir-date-month]'
      );


    const dayInput =
      root.querySelector(
        '[data-ir-date-day]'
      );


    if (
      !yearInput ||
      !monthInput ||
      !dayInput
    ) {

      return;
    }


    yearInput.addEventListener(
      'input',
      function () {

        const value =
          digitsOnly(
            yearInput.value,
            4
          );


        yearInput.value =
          value;


        root.irEmbroideryState.dateYear =
          value;


        updateDateValidation(root);

        updatePreview(root);

      }
    );


    monthInput.addEventListener(
      'input',
      function () {

        const value =
          digitsOnly(
            monthInput.value,
            2
          );


        monthInput.value =
          value;


        root.irEmbroideryState.dateMonth =
          value;


        updateDateValidation(root);

        updatePreview(root);

      }
    );


    dayInput.addEventListener(
      'input',
      function () {

        const value =
          digitsOnly(
            dayInput.value,
            2
          );


        dayInput.value =
          value;


        root.irEmbroideryState.dateDay =
          value;


        updateDateValidation(root);

        updatePreview(root);

      }
    );
  }


  /* =========================================
    DATE VALIDATION
  ========================================= */

  function updateDateValidation(root) {

    const state =
      root.irEmbroideryState;


    const validationElement =
      root.querySelector(
        '[data-ir-date-validation]'
      );
    const yearInput =
      root.querySelector(
        '[data-ir-date-year]'
      );


    const monthInput =
      root.querySelector(
        '[data-ir-date-month]'
      );


    const dayInput =
      root.querySelector(
        '[data-ir-date-day]'
      );


    if (
      state.dateMode !==
      'include'
    ) {

      setValidation(
        validationElement,
        ''
      );
[
        yearInput,
        monthInput,
        dayInput
      ].forEach(
        input =>
          input?.classList.remove(
            'has-error'
          )
      );


      state.generatedDate =
        '';


      return;
    }


    const validation =
      getDateValidation(root);


    const generated =
      generateDate(root);


    state.generatedDate =
      generated;


    if (
      !validation.complete
    ) {

      setValidation(
        validationElement,
        ''
      );
[
        yearInput,
        monthInput,
        dayInput
      ].forEach(
        input =>
          input?.classList.remove(
            'has-error'
          )
      );


      return;
    }


    if (
      !validation.valid
    ) {

      setValidation(
        validationElement,
        validation.message
      );
[
        yearInput,
        monthInput,
        dayInput
      ].forEach(
        input =>
          input?.classList.add(
            'has-error'
          )
      );


      return;
    }


    setValidation(
      validationElement,
      ''
    );


    [
      yearInput,
      monthInput,
      dayInput
    ].forEach(
      input =>
        input?.classList.remove(
          'has-error'
        )
    );
}


  function resetDateInputs(root) {

    const yearInput =
      root.querySelector(
        '[data-ir-date-year]'
      );


    const monthInput =
      root.querySelector(
        '[data-ir-date-month]'
      );


    const dayInput =
      root.querySelector(
        '[data-ir-date-day]'
      );


    [
      yearInput,
      monthInput,
      dayInput
    ].forEach(
      input => {

        if (!input) {

          return;
        }


        input.value =
          '';


        input.classList.remove(
          'has-error'
        );

      }
    );
setValidation(
      root.querySelector(
        '[data-ir-date-validation]'
      ),
      ''
    );
  }



  /* =========================================
    THREAD COLOR
  ========================================= */

  function getThreadColorName(threadId) {

    return (
      THREAD_COLORS[
        threadId
      ] || ''
    );
  }


  /* =========================================
    FABRIC PREVIEW BACKGROUND
    選択中の尾州ツイード画像を最終プレビュー背景へ反映
  ========================================= */

  function updatePreviewFabricBackground(root) {

    const finalPreview =
      root.querySelector('[data-ir-final-preview-text]');

    if (!finalPreview) {
      return;
    }

    const fabricCode =
      root.irEmbroideryTarget?.fabricCode || '';

    const imageUrl =
      fabricCode
        ? EMBROIDERY_FABRIC_PREVIEW_IMAGES[fabricCode] || ''
        : '';

    if (!imageUrl) {
      finalPreview.style.removeProperty('background-image');
      return;
    }

    finalPreview.style.backgroundImage =
      `url("${imageUrl}")`;
  }


  function updatePreviewThreadColor(root) {

    const previews = [
      root.querySelector('[data-ir-preview-text]'),
      root.querySelector('[data-ir-final-preview-text]')
    ].filter(Boolean);

    const threadId =
      root.irEmbroideryState?.threadColorId;

    const color =
      threadId && THREAD_SWATCHES[threadId]
        ? THREAD_SWATCHES[threadId]
        : '';

    previews.forEach(preview => {
      preview.style.color = color;
    });
  }


  function hideEmbroiderySample(root) {

    const sample = root.querySelector('[data-ir-sample]');
    const image = root.querySelector('[data-ir-sample-image]');

    if (sample) {
      sample.hidden = true;
    }

    if (image) {
      image.removeAttribute('src');
      image.alt = '';
    }
  }


  function renderEmbroiderySample(root) {

    const sample = root.querySelector('[data-ir-sample]');
    const image = root.querySelector('[data-ir-sample-image]');
    const description = root.querySelector('[data-ir-sample-description]');
    const reference = root.querySelector('[data-ir-sample-reference]');

    if (!sample || !image) {
      return;
    }

    const target = root.irEmbroideryTarget;
    const threadId = Number(root.irEmbroideryState?.threadColorId);

    if (!target || target.eligible !== true || !threadId) {
      hideEmbroiderySample(root);
      return;
    }

    const sampleThreads =
      Array.isArray(target.sampleThreads)
        ? target.sampleThreads
        : [];

    if (!sampleThreads.includes(threadId)) {
      hideEmbroiderySample(root);
      return;
    }

    const sourceFabricCode =
      target.sampleSourceFabric || target.fabricCode;

    const imageUrl =
      EMBROIDERY_SAMPLE_IMAGES[sourceFabricCode]?.[threadId] || '';

    /* URL未登録の間はお客様には表示しない */
    if (!imageUrl) {
      hideEmbroiderySample(root);
      return;
    }

    const sourceFabric = FABRICS[sourceFabricCode];
    const sourceFabricLabel =
      sourceFabric?.label || target.fabricLabel || '';

    const threadName = getThreadColorName(threadId);

    image.src = imageUrl;
    image.alt =
      `${sourceFabricLabel}に${threadName}の糸で刺繍した仕上がりイメージ`;

    if (description) {
      description.textContent =
        `${target.fabricLabel} × ${threadName}を選択した際の参考イメージです。`;
    }

    const isReferenceFabric =
      sourceFabricCode !== target.fabricCode;

    if (reference) {

      if (isReferenceFabric) {
        reference.hidden = false;
        reference.textContent =
          `※こちらは「${sourceFabricLabel}」に刺繍した参考例です。生地の色・織り柄により、実際の見え方は異なります。`;
      } else {
        reference.hidden = true;
        reference.textContent = '';
      }
    }

    sample.hidden = false;
  }


  function renderThreadOptions(root) {

    const container =
      root.querySelector(
        '[data-ir-thread-options]'
      );


    const currentValue =
      root.querySelector(
        '[data-ir-thread-current-value]'
      );


    const note =
      root.querySelector(
        '[data-ir-thread-note]'
      );


    if (!container) {

      return;
    }


    const target =
      root.irEmbroideryTarget;


    const state =
      root.irEmbroideryState;


    container.innerHTML =
      '';


    if (
      !target ||
      target.eligible !== true
    ) {

      if (currentValue) {

        currentValue.textContent =
          '未選択';
      }


      if (note) {

        note.hidden =
          true;


        note.textContent =
          '';
      }


      updatePreviewThreadColor(root);

      hideEmbroiderySample(root);

      return;
    }


    const allowed =
      Array.isArray(
        target.allowedThreads
      )
        ? target.allowedThreads
        : [];


    const recommended =
      Array.isArray(
        target.recommendedThreads
      )
        ? target.recommendedThreads
        : [];


    if (
      state.threadColorId &&
      !allowed.includes(
        Number(
          state.threadColorId
        )
      )
    ) {

      state.threadColorId =
        null;
    }


    allowed.forEach(
      threadId => {

        const button =
          document.createElement(
            'button'
          );


        button.type =
          'button';


        button.className =
          'ir-embroidery-thread-button';


        button.dataset.irThreadId =
          String(threadId);


        const selected =
          Number(
            state.threadColorId
          ) ===
          Number(threadId);


        button.classList.toggle(
          'is-selected',
          selected
        );


        button.setAttribute(
          'aria-pressed',
          String(selected)
        );


        const swatch =
          document.createElement(
            'span'
          );


        swatch.className =
          'ir-embroidery-thread-button__swatch';


        swatch.style.setProperty(
          '--ir-thread-swatch',
          THREAD_SWATCHES[
            threadId
          ] || '#dddddd'
        );


        const body =
          document.createElement(
            'span'
          );


        body.className =
          'ir-embroidery-thread-button__body';


        const name =
          document.createElement(
            'span'
          );


        name.className =
          'ir-embroidery-thread-button__name';


        name.textContent =
          getThreadColorName(
            threadId
          );


        body.appendChild(
          name
        );


        if (
          recommended.includes(
            threadId
          )
        ) {

          const badge =
            document.createElement(
              'span'
            );


          badge.className =
            'ir-embroidery-thread-button__badge';


          badge.textContent =
            'おすすめ';


          body.appendChild(
            badge
          );
        }


        button.appendChild(
          swatch
        );


        button.appendChild(
          body
        );


        container.appendChild(
          button
        );

      }
    );


    if (
      currentValue
    ) {

      currentValue.textContent =
        state.threadColorId
          ? getThreadColorName(
              state.threadColorId
            )
          : '未選択';
    }


    const finalThreadValue =
      root.querySelector(
        '[data-ir-final-thread-value]'
      );

    if (finalThreadValue) {

      finalThreadValue.textContent =
        state.threadColorId
          ? getThreadColorName(
              state.threadColorId
            )
          : '未選択';
    }


    if (note) {

      if (target.note) {

        note.hidden =
          false;


        note.textContent =
          target.note;

      } else {

        note.hidden =
          true;


        note.textContent =
          '';
      }
    }


    updatePreviewThreadColor(root);

    renderEmbroiderySample(root);
  }


  function selectThreadColor(
    root,
    threadId
  ) {

    const target =
      root.irEmbroideryTarget;


    if (
      !target ||
      target.eligible !== true
    ) {

      return;
    }


    const numericId =
      Number(threadId);


    const allowed =
      Array.isArray(
        target.allowedThreads
      )
        ? target.allowedThreads
        : [];


    if (
      !allowed.includes(
        numericId
      )
    ) {

      return;
    }


    root.irEmbroideryState.threadColorId =
      numericId;


    renderThreadOptions(root);

    updateEmbroideryPriceUI(root);

    updatePreview(root);
  }


  function setupThreadOptions(root) {

    const container =
      root.querySelector(
        '[data-ir-thread-options]'
      );


    if (!container) {

      return;
    }


    container.addEventListener(
      'click',
      event => {

        const button =
          event.target.closest(
            '[data-ir-thread-id]'
          );


        if (!button) {

          return;
        }


        selectThreadColor(
          root,
          button.dataset.irThreadId
        );

      }
    );
  }


  /* =========================================
    RESET CUSTOMIZER
  ========================================= */

  function resetCustomizer(root) {

    root.irEmbroideryState =
      createInitialState();


    /* SCENE */

    root
      .querySelectorAll(
        '[data-scene-id]'
      )
      .forEach(
        button => {

          button.classList.remove(
            'is-selected'
          );


          button.setAttribute(
            'aria-pressed',
            'false'
          );

        }
      );


    /* MESSAGE */

    const messageField =
      root.querySelector(
        '[data-ir-message-field]'
      );


    const messageOptions =
      root.querySelector(
        '[data-ir-message-options]'
      );


    if (messageField) {

      messageField.hidden =
        true;
    }


    if (messageOptions) {

      messageOptions.innerHTML =
        '';
    }


    hideNumberField(root);


    /* NAME */

    root
      .querySelectorAll(
        '[data-ir-name-mode]'
      )
      .forEach(
        button => {

          button.classList.remove(
            'is-selected'
          );


          button.setAttribute(
            'aria-pressed',
            'false'
          );

        }
      );


    const oneField =
      root.querySelector(
        '[data-ir-one-name-field]'
      );


    const twoField =
      root.querySelector(
        '[data-ir-two-name-field]'
      );


    if (oneField) {

      oneField.hidden =
        true;
    }


    if (twoField) {

      twoField.hidden =
        true;
    }


    resetNameInputs(root);


    /* DATE */

    root
      .querySelectorAll(
        '[data-ir-date-mode]'
      )
      .forEach(
        button => {

          button.classList.remove(
            'is-selected'
          );


          button.setAttribute(
            'aria-pressed',
            'false'
          );

        }
      );


    const dateField =
      root.querySelector(
        '[data-ir-date-field]'
      );


    if (dateField) {

      dateField.hidden =
        true;
    }


    resetDateInputs(root);


    updateMessageValidation(root);

    updateNameValidation(root);

    updateDateValidation(root);

    updatePreview(root);

    renderThreadOptions(root);
  }





  /* =========================================
    SHOPIFY CART INTEGRATION
  ========================================= */

  function isMetallicThread(threadColorId) {

    return METALLIC_THREAD_IDS.includes(
      Number(threadColorId)
    );
  }


  function getEmbroideryServiceType(root) {

    const threadColorId =
      root.irEmbroideryState?.threadColorId;

    return isMetallicThread(threadColorId)
      ? 'metallic'
      : 'matte';
  }


  function getEmbroideryServiceVariantId(root) {

    const type =
      getEmbroideryServiceType(root);

    return EMBROIDERY_SERVICE_VARIANTS[type];
  }


  function getEmbroideryServicePrice(root) {

    const type =
      getEmbroideryServiceType(root);

    return EMBROIDERY_SERVICE_PRICES[type];
  }


  function formatYen(value) {

    return Number(value || 0).toLocaleString('ja-JP');
  }


  function updateEmbroideryPriceUI(root) {

    const price =
      getEmbroideryServicePrice(root);

    const confirmPrice =
      root.querySelector(
        '[data-ir-confirm-button] strong'
      );

    if (confirmPrice) {
      confirmPrice.textContent =
        `＋${formatYen(price)}円`;
    }
  }


  function createEmbroideryLinkId() {

    if (
      window.crypto &&
      typeof window.crypto.randomUUID === 'function'
    ) {
      return window.crypto.randomUUID();
    }

    return `emb-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }


  function getEmbroiderySnapshot(root) {

    const state = root.irEmbroideryState || {};
    const target = root.irEmbroideryTarget || {};
    const lines = getPreviewLines(root);

    return JSON.stringify({
      lines,
      threadColorId: Number(state.threadColorId || 0),
      fabricCode: target.fabricCode || '',
      fabricLabel: target.fabricLabel || '',
      productCode: target.productCode || '',
      size: target.size || ''
    });
  }

  
  function hasUnconfirmedEmbroideryInput(root) {

    const state = root.irEmbroideryState || {};

    // 確定済みなら未確定入力として扱わない
    if (state.confirmed === true) {
      return false;
    }

    // 一度確定した後に内容が変更された場合
    if (state.hasBeenConfirmed === true) {
      return true;
    }

    // 刺繍文字が入力されている場合
    const lines = getPreviewLines(root);

    const hasText = lines.some(
      (line) => String(line || '').trim().length > 0
    );

    // 糸色が選択されている場合
    const hasThreadColor =
      state.threadColorId !== null &&
      state.threadColorId !== undefined;

    return hasText || hasThreadColor;
  }


  function updateConfirmationUI(
    root,
    confirmed
  ) {

    const state =
      root.irEmbroideryState;

    const button =
      root.querySelector(
        '[data-ir-confirm-button]'
      );

    const label =
      root.querySelector(
        '[data-ir-confirm-button-label]'
      );

    if (button) {
      button.classList.toggle(
        'is-confirmed',
        Boolean(confirmed)
      );

      button.setAttribute(
        'aria-pressed',
        confirmed ? 'true' : 'false'
      );
    }

    if (label) {

      if (confirmed) {

        label.textContent =
          '✓ 刺繍内容を設定済み';

      } else if (
        state?.hasBeenConfirmed
      ) {

        label.textContent =
          '修正内容を反映する';

      } else {

        label.textContent =
          'この内容で刺繍を追加する';
      }
    }
  }


  function invalidateEmbroideryConfirmation(root) {

    const state = root.irEmbroideryState;

    if (!state || !state.confirmed) {
      return;
    }

    if (
      state.confirmedSnapshot !==
      getEmbroiderySnapshot(root)
    ) {
      state.confirmed = false;
      state.confirmedSnapshot = '';

      updateConfirmationUI(
        root,
        false
      );

      const message =
        root.querySelector('[data-ir-confirm-message]');

      if (message) {
        message.hidden = true;
        message.classList.remove('is-success');
        message.innerHTML = '';
      }
    }
  }


  function getProductForm(root) {

    const formId =
      root.dataset.productFormId || '';

    if (formId) {
      const byId =
        document.getElementById(formId);

      if (byId) {
        return byId;
      }
    }

    const section =
      root.closest('.shopify-section');

    return (
      section?.querySelector('product-form form') ||
      section?.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form') ||
      null
    );
  }


  function getMainItemFromForm(form) {

    const formData =
      new FormData(form);

    const variantId =
      Number(formData.get('id'));

    const quantity =
      Math.max(
        1,
        Number(formData.get('quantity')) || 1
      );

    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match =
        key.match(/^properties\[(.+)\]$/);

      if (!match) {
        continue;
      }

      const stringValue =
        String(value ?? '').trim();

      if (stringValue !== '') {
        properties[match[1]] = stringValue;
      }
    }

    const item = {
      id: variantId,
      quantity,
      properties
    };

    const sellingPlan =
      formData.get('selling_plan');

    if (sellingPlan) {
      item.selling_plan =
        Number(sellingPlan) || sellingPlan;
    }

    return item;
  }


  function buildEmbroideryProperties(
    root,
    linkId
  ) {

    const state =
      root.irEmbroideryState || {};

    const target =
      root.irEmbroideryTarget || {};

    const lines =
      getPreviewLines(root);


    const properties = {
      '刺繍1段目': lines[0] || '',
      '刺繍2段目': lines[1] || '',
      '刺繍3段目': lines[2] || '',
      '糸色':
        THREAD_COLORS[
          Number(state.threadColorId)
        ] || '',
      '生地':
        target.fabricLabel || '',
      '刺繍連携ID': linkId
    };

    Object.keys(properties).forEach(key => {
      if (
        key !== '刺繍連携ID' &&
        !properties[key]
      ) {
        delete properties[key];
      }
    });

    return properties;
  }


  async function addBouquetAndEmbroideryToCart(
    root,
    form
  ) {

    const state =
      root.irEmbroideryState;

    if (
      !state ||
      !state.confirmed ||
      state.confirmedSnapshot !==
        getEmbroiderySnapshot(root)
    ) {
      throw new Error('刺繍内容をもう一度確定してください。');
    }

    const mainItem =
      getMainItemFromForm(form);

    if (!mainItem.id) {
      throw new Error('商品のバリエーションを確認できませんでした。');
    }

    const linkId =
      createEmbroideryLinkId();

    mainItem.properties = {
      ...(mainItem.properties || {}),
      '刺繍オプション': 'あり',
      '刺繍連携ID': linkId
    };

    const embroideryItem = {
      id: getEmbroideryServiceVariantId(root),
      quantity: mainItem.quantity,
      properties:
        buildEmbroideryProperties(
          root,
          linkId
        )
    };

    const response =
      await fetch(
        window.routes?.cart_add_url ||
          '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            'Accept':
              'application/json'
          },
          body: JSON.stringify({
            /*
              Shopifyカート表示を
              「メイン商品 → 刺繍サービス」
              の順にするため、Ajax追加時は
              刺繍サービス → メイン商品の順で送信する。
            */
            items: [
              embroideryItem,
              mainItem
            ]
          })
        }
      );

    if (!response.ok) {
      let message =
        'カートへの追加に失敗しました。';

      try {
        const data =
          await response.json();

        message =
          data.description ||
          data.message ||
          message;
      } catch (error) {}

      throw new Error(message);
    }

    return response.json();
  }


  function setupCartIntegration(root) {

    // オーダーメイドフォームでは、カート追加処理を専用JSに任せる
  if (root.closest('[data-ir-order-made]')) {
    return;
  }

    const form =
      getProductForm(root);

    if (!form) {
      return;
    }

    form.addEventListener(
      'submit',
      async event => {

        const state =
          root.irEmbroideryState;

        /*
          刺繍を確定していない場合は、
          Shopify本来のカート追加処理をそのまま使用。
        */
        if (!state?.confirmed) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitButton =
          form.querySelector(
            '[type="submit"]'
          );

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute(
            'aria-disabled',
            'true'
          );
        }

        try {
          const errors =
            getFinalConfirmationErrors(root);

          if (errors.length > 0) {
            state.confirmed = false;
            state.confirmedSnapshot = '';

            updateConfirmationUI(
              root,
              false
            );

            showFinalConfirmationMessage(
              root,
              errors
            );

            root
              .querySelector(
                '[data-ir-confirm-message]'
              )
              ?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });

            return;
          }

          await addBouquetAndEmbroideryToCart(
            root,
            form
          );

          /*
            2商品を確実に確認できるよう、
            追加成功後はカートページへ移動。
          */
          window.location.href =
            window.routes?.cart_url ||
            '/cart';

        } catch (error) {

          const message =
            root.querySelector(
              '[data-ir-confirm-message]'
            );

          if (message) {
            message.classList.remove(
              'is-success'
            );
            message.textContent =
              error?.message ||
              'カートへの追加に失敗しました。もう一度お試しください。';
            message.hidden = false;
          }

        } finally {

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute(
              'aria-disabled'
            );
          }
        }
      },
      true
    );
  }


  /* =========================================
    FINAL CONFIRM VALIDATION
  ========================================= */

  function getFinalConfirmationErrors(root) {

  const errors = [];
  const state = root.irEmbroideryState;
  const target = root.irEmbroideryTarget;

  if (!state || !target || target.eligible !== true) {
    errors.push(
      '現在選択している商品・生地では刺繍サービスをご利用いただけません。'
    );

    return errors;
  }


  /* =========================================
    刺繍の仕上がりについて
    同意チェック
  ========================================= */

  const agreement =
    root.querySelector(
      '[data-ir-embroidery-agreement]'
    );

  const agreementValidation =
    root.querySelector(
      '[data-ir-embroidery-agreement-validation]'
    );


  if (
    !agreement ||
    !agreement.checked
  ) {

    errors.push(
      '「刺繍の仕上がりについて」を確認し、チェックを入れてください。'
    );

    setValidation(
      agreementValidation,
      '「刺繍の仕上がりについて」を確認し、チェックを入れてください。'
    );

  } else {

    setValidation(
      agreementValidation,
      ''
    );
  }


  /* =========================================
    刺繍内容
  ========================================= */

  const rawMessage =
    generateMessage(root);

  const rawName =
    generateName(root);

  const rawDate =
    generateDate(root);


  const hasAnyContent =
    Boolean(
      rawMessage ||
      rawName ||
      rawDate
    );


  if (!hasAnyContent) {

    errors.push(
      'メッセージ・お名前・日付のうち、1つ以上を入力してください。'
    );
  }


  /* =========================================
    メッセージ
  ========================================= */

  if (state.messageId) {

    const messageConfig =
      getMessageConfig(
        state.sceneId,
        state.messageId
      );


    if (
      messageConfig?.requiresNumber &&
      !toOrdinal(state.numberValue)
    ) {

      errors.push(
        '選択したメッセージに必要な数字を入力してください。'
      );
    }


    if (
      rawMessage &&
      !isWithinLineLimit(rawMessage)
    ) {

      errors.push(
        `メッセージは${MAX_LINE_LENGTH}文字以内にしてください。`
      );
    }
  }


  /* =========================================
    お名前
  ========================================= */

  if (
    state.nameMode ===
    'one'
  ) {

    const first =
      (
        state.firstName ||
        ''
      ).trim();


    if (!first) {

      errors.push(
        '刺繍するお名前を入力してください。'
      );
    }
  }


  if (
    state.nameMode ===
    'two'
  ) {

    const first =
      (
        state.firstName ||
        ''
      ).trim();

    const second =
      (
        state.secondName ||
        ''
      ).trim();


    if (
      !first ||
      !second
    ) {

      errors.push(
        '2名分のお名前を両方入力してください。'
      );
    }
  }


  if (
    rawName &&
    !isWithinLineLimit(rawName)
  ) {

    errors.push(
      `お名前は完成した1行全体で${MAX_LINE_LENGTH}文字以内にしてください。`
    );
  }


  /* =========================================
    日付
  ========================================= */

  if (
    state.dateMode ===
    'include'
  ) {

    const dateValidation =
      getDateValidation(root);


    if (
      !dateValidation.complete
    ) {

      errors.push(
        '刺繍する日付をすべて入力してください。'
      );

    } else if (
      !dateValidation.valid
    ) {

      errors.push(
        dateValidation.message ||
        '正しい日付を入力してください。'
      );
    }
  }


  if (
    rawDate &&
    !isWithinLineLimit(rawDate)
  ) {

    errors.push(
      `日付は${MAX_LINE_LENGTH}文字以内にしてください。`
    );
  }


  /* =========================================
    糸色
  ========================================= */

  if (
    !state.threadColorId
  ) {

    errors.push(
      '刺繍する糸色を選択してください。'
    );

  } else {

    const allowedThreads =
      Array.isArray(
        target.allowedThreads
      )
        ? target.allowedThreads
        : [];


    if (
      !allowedThreads.includes(
        Number(
          state.threadColorId
        )
      )
    ) {

      errors.push(
        '現在の生地で選択できる糸色を選び直してください。'
      );
    }
  }


  /* =========================================
    最大3行
  ========================================= */

  const lines =
    getPreviewLines(root);


  if (
    lines.length > 3
  ) {

    errors.push(
      '刺繍内容は最大3行までです。'
    );
  }


  return [
    ...new Set(errors)
  ];
}


  function showFinalConfirmationMessage(
    root,
    errors
  ) {

    const message =
      root.querySelector(
        '[data-ir-confirm-message]'
      );

    if (!message) {
      return;
    }

    message.classList.remove('is-success');
    message.innerHTML = '';

    if (errors.length === 0) {
      message.classList.add('is-success');

      const title =
        document.createElement('strong');

      title.className =
        'ir-embroidery-confirm__success-title';

      title.textContent =
        '✓ 刺繍内容を設定しました';

      const detail =
        document.createElement('span');

      detail.className =
        'ir-embroidery-confirm__success-detail';

      detail.textContent =
        `この内容で刺繍サービス（＋${formatYen(getEmbroideryServicePrice(root))}円）が追加されます。`;

      message.appendChild(title);
      message.appendChild(detail);
      message.hidden = false;
      return;
    }

    const title =
      document.createElement('strong');

    title.textContent =
      '以下の内容をご確認ください。';

    const list =
      document.createElement('ul');

    errors.forEach(error => {
      const item =
        document.createElement('li');

      item.textContent = error;
      list.appendChild(item);
    });

    message.appendChild(title);
    message.appendChild(list);
    message.hidden = false;
  }


  function setupFinalConfirmation(root) {

    const button =
      root.querySelector(
        '[data-ir-confirm-button]'
      );

    if (!button) {
      return;
    }

    button.addEventListener(
      'click',
      () => {

        updateMessageValidation(root);
        updateNameValidation(root);
        updateDateValidation(root);
        updatePreview(root);

        const errors =
          getFinalConfirmationErrors(root);

        showFinalConfirmationMessage(
          root,
          errors
        );

        if (errors.length === 0) {
          root.irEmbroideryState.confirmed = true;
          root.irEmbroideryState.hasBeenConfirmed = true;
          root.irEmbroideryState.confirmedSnapshot =
            getEmbroiderySnapshot(root);

          updateConfirmationUI(
            root,
            true
          );
        } else {
          root.irEmbroideryState.confirmed = false;
          root.irEmbroideryState.confirmedSnapshot = '';

          updateConfirmationUI(
            root,
            false
          );
        }
      }
    );
  }


  /* =========================================
    ENTRY RENDER
  ========================================= */

  function renderEmbroidery(
    root,
    variant
  ) {

    const previousTarget =
      root.irEmbroideryTarget ||
      null;


    const target =
      getEmbroideryTarget(
        root,
        variant
      );


    updateEmbroiderySizeImage(
      root,
      target
    );


    const status =
      root.querySelector(
        '[data-ir-embroidery-status]'
      );


    const button =
      root.querySelector(
        '[data-ir-embroidery-toggle]'
      );


    const buttonText =
      root.querySelector(
        '[data-ir-toggle-text]'
      );


    const panel =
      root.querySelector(
        '[data-ir-embroidery-panel]'
      );


    const currentFabric =
      root.querySelector(
        '[data-ir-current-fabric]'
      );


    const fabricName =
      root.querySelector(
        '[data-ir-fabric-name]'
      );


    if (
      !status ||
      !button ||
      !buttonText ||
      !panel
    ) {

      return;
    }


    status.classList.remove(
      'is-available',
      'is-unavailable',
      'is-waiting'
    );


    root.irEmbroideryTarget =
      target;

    updatePreviewFabricBackground(root);


    /* 対応 → 非対応になった場合だけリセット */

    if (
      previousTarget &&
      previousTarget.eligible === true &&
      target.eligible !== true
    ) {

      resetCustomizer(root);


      closeEmbroideryPanel(
        button,
        panel
      );
    }


    /* CURRENT FABRIC */

    if (
      target.fabricLabel &&
      currentFabric &&
      fabricName
    ) {

      currentFabric.hidden =
        false;


      fabricName.textContent =
        `${target.fabricLabel}（${target.fabricCode}）`;

    } else if (
      currentFabric &&
      fabricName
    ) {

      currentFabric.hidden =
        true;


      fabricName.textContent =
        '';
    }


    /* AVAILABLE */

    if (
      target.eligible ===
      true
    ) {

      status.classList.add(
        'is-available'
      );


      status.textContent =
        target.note
          ? `このツイードは刺繍サービスをご利用いただけます。`
          : 'このツイードは刺繍サービスをご利用いただけます。';


      button.disabled =
        false;


      if (
        button.getAttribute(
          'aria-expanded'
        ) === 'true'
      ) {

        buttonText.textContent =
          '刺繍設定を閉じる';

      } else {

        buttonText.textContent =
          'オリジナル刺繍を追加する';
      }

    }


    /* WAITING */

    else if (
      target.eligible ===
      null
    ) {

      status.classList.add(
        'is-waiting'
      );


      status.textContent =
        target.message;


      button.disabled =
        true;


      buttonText.textContent =
        'ツイード生地を選択してください';


      closeEmbroideryPanel(
        button,
        panel
      );

    }


    /* UNAVAILABLE */

    else {

      status.classList.add(
        'is-unavailable'
      );


      status.textContent =
        target.message ||
        'この商品は刺繍サービス対象外です。';


      button.disabled =
        true;


      if (
        target.reason ===
        'unsupported_fabric'
      ) {

        buttonText.textContent =
          'このツイードは刺繍対象外です';

      } else {

        buttonText.textContent =
          'この商品は刺繍対象外です';
      }


      closeEmbroideryPanel(
        button,
        panel
      );

    }


    renderThreadOptions(root);


    console.log(
      '[IRiller Embroidery]',
      {
        target,
        state:
          root.irEmbroideryState
      }
    );
  }


  /* =========================================
    PANEL
  ========================================= */

  function closeEmbroideryPanel(
    button,
    panel
  ) {

    if (
      !button ||
      !panel
    ) {

      return;
    }


    button.setAttribute(
      'aria-expanded',
      'false'
    );


    panel.hidden =
      true;
  }


  function setupPanelToggle(root) {

    const button =
      root.querySelector(
        '[data-ir-embroidery-toggle]'
      );


    const panel =
      root.querySelector(
        '[data-ir-embroidery-panel]'
      );


    if (
      !button ||
      !panel
    ) {

      return;
    }


    button.addEventListener(
      'click',
      function () {

        if (
          button.disabled
        ) {

          return;
        }


        const isOpen =
          button.getAttribute(
            'aria-expanded'
          ) === 'true';


        const buttonText =
          button.querySelector(
            '[data-ir-toggle-text]'
          );


        if (isOpen) {

          button.setAttribute(
            'aria-expanded',
            'false'
          );


          panel.hidden =
            true;


          if (buttonText) {

            buttonText.textContent =
              'オリジナル刺繍を追加する';
          }


          return;
        }


        
        button.setAttribute(
          'aria-expanded',
          'true'
        );


        panel.hidden =
          false;


        // 刺繍設定を利用開始したことを記録
        if (root.irEmbroideryState) {
          root.irEmbroideryState.hasStarted = true;
        }



        if (buttonText) {

          buttonText.textContent =
            '刺繍設定を閉じる';
        }

      }
    );
  }


  /* =========================================
    INITIAL VARIANT
  ========================================= */

  function getInitialVariant(root) {

    const jsonElement =
      root.querySelector(
        '[data-ir-initial-variant]'
      );


    if (!jsonElement) {

      return null;
    }


    try {

      return JSON.parse(
        jsonElement.textContent
      );

    } catch (error) {

      console.error(
        '[IRiller Embroidery] Initial variant JSON error:',
        error
      );


      return null;
    }
  }


  function setCurrentVariant(
    root,
    variant
  ) {

    root.irCurrentVariant =
      variant || null;
  }


  function getCurrentVariant(root) {

    return (
      root.irCurrentVariant ||
      getInitialVariant(root)
    );
  }


  /* =========================================
    ODM LISTENER
  ========================================= */

  function setupOdmFabricListener(root) {

    document.addEventListener(
      'change',
      function (event) {

        const target =
          event.target;


        if (
          !target ||
          typeof target.matches !==
            'function'
        ) {

          return;
        }


        if (
          !target.matches(
            'input[name="properties[ツイード生地]"]'
          )
        ) {

          return;
        }

        
        // 生地変更後は、確定済みの刺繍内容を再確認してもらう
        if (root.irEmbroideryState?.confirmed) {
          root.irEmbroideryState.confirmed = false;
        }

        renderEmbroidery(
          root,
          getCurrentVariant(root)
        );

      }
    );
  }


  /* =========================================
    SHOPIFY VARIANT LISTENER
  ========================================= */

  function setupVariantListener(root) {

    if (
      typeof subscribe !==
        'function' ||

      typeof PUB_SUB_EVENTS ===
        'undefined'
    ) {

      console.warn(
        '[IRiller Embroidery] Shopify variant event system was not found.'
      );


      return;
    }


    subscribe(
      PUB_SUB_EVENTS.variantChange,
      event => {

        const data =
          event?.data;


        if (!data) {

          return;
        }


        if (
          data.sectionId &&

          String(
            data.sectionId
          ) !==

          String(
            root.dataset.sectionId
          )
        ) {

          return;
        }


        const variant =
          data.variant || null;


        setCurrentVariant(
          root,
          variant
        );


        renderEmbroidery(
          root,
          variant
        );

      }
    );
  }


  /* =========================================
    INITIALIZE
  ========================================= */

  function initializeEmbroidery(root) {

    if (
      !root ||
      root.dataset.irInitialized ===
        'true'
    ) {

      return;
    }


    root.dataset.irInitialized =
      'true';


    root.irEmbroideryState =
      createInitialState();


    renderSceneOptions(root);

    setupNumberInput(root);

    setupNameMode(root);

    setupNameInputs(root);

    setupConnectors(root);

    setupDateMode(root);

    setupDateInputs(root);

    setupOrderControl(root);

    setupThreadOptions(root);

    updateEmbroideryPriceUI(root);

    setupFinalConfirmation(root);

    setupCartIntegration(root);


    const initialVariant =
      getInitialVariant(root);


    setCurrentVariant(
      root,
      initialVariant
    );


    renderEmbroidery(
      root,
      initialVariant
    );


    setupPanelToggle(root);

    setupOdmFabricListener(root);

    setupVariantListener(root);

  }


  /* =========================================
    INITIALIZE ALL
  ========================================= */

  function initializeAllEmbroideryCustomizers() {

    document
      .querySelectorAll(
        '[data-ir-embroidery]'
      )
      .forEach(
        initializeEmbroidery
      );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAllEmbroideryCustomizers
    );

  } else {

    initializeAllEmbroideryCustomizers();

  }

    // ==========================================
  // IRiller | オーダーメイド刺繍連携API
  // ==========================================
  window.IRillerEmbroidery = {
    
    hasUnconfirmedInput(orderMadeRoot) {
      const root = orderMadeRoot?.querySelector('[data-ir-embroidery]');

      if (!root) return false;

      return hasUnconfirmedEmbroideryInput(root);
    },

    getOrderMadeItem(orderMadeRoot) {
      const root = orderMadeRoot?.querySelector('[data-ir-embroidery]');
      if (!root) return null;

      const state = root.irEmbroideryState;
      if (!state?.confirmed) return null;

      if (state.confirmedSnapshot !== getEmbroiderySnapshot(root)) {
        throw new Error('刺繍内容が変更されています。もう一度、刺繍内容を確定してください。');
      }

      const variantId = Number(getEmbroideryServiceVariantId(root));
      if (!Number.isSafeInteger(variantId) || variantId <= 0) {
        throw new Error('刺繍サービスの種類を確認できませんでした。');
      }

      return {
        id: variantId,
        quantity: 1,
        properties: buildEmbroideryProperties(root, '')
      };
    }
  };

})();